import RouterAuth from "./RouterAuth";
export default RouterAuth;



// WEBPACK FOOTER //
// ./src/components/RouterAuth/index.js